import React from "react";
import { Slider } from "antd";
import "./AntdSliderSelect.css";

const SliderSelect = (props) => {
  const { value, onChangeHandler } = props;
  const marks = {
    0: {
      style: {
        color: "#000000",
        fontSize: "16px",
        textAlign: "left",
        marginLeft: "76px",
      },
      label: (
        <p>
          0 <br /> I am not doing too good{" "}
        </p>
      ),
    },
    5: {
      style: {
        color: "#000000",
        fontSize: "16px",
      },
      label: (
        <p>
          5 <br /> I am doing okay{" "}
        </p>
      ),
    },
    10: {
      style: {
        color: "#000000",
        fontSize: "16px",
        textAlign: "right",
        left: "99%",
        display: "contents",
      },
      label: (
        <p>
          10 <br /> I am doing great!{" "}
        </p>
      ),
    },
  };

  return (
    <>
      <Slider        
        onChange={onChangeHandler}
        marks={marks}
        step={1}
        min={0}
        max={10}
        value={value}
      />
    </>
  );
};

export default SliderSelect;
